var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.root},[_c('div',{class:_vm.$style.rootinner,domProps:{"innerHTML":_vm._s(_vm.productmessage)}})])}
var staticRenderFns = []

export { render, staticRenderFns }